import { useCallback, useEffect } from "react";

const MlsSplash = ({ show, onClose, propertyData }) => {
  // Close on Escape key
  useEffect(() => {
    if (!show) return;
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [show, onClose]);

  const handleBackdropClick = useCallback(
    (e) => {
      if (e.target === e.currentTarget) onClose?.();
    },
    [onClose]
  );

  if (!show) return null;

  const { photo, address, city, state, matchScore } = propertyData || {};

  return (
    <div className="mls-splash" onClick={handleBackdropClick}>
      <div className="mls-splash__card">
        {/* Property preview */}
        {photo && (
          <div className="mls-splash__photo-wrap">
            <img src={photo} alt={address || "Property"} className="mls-splash__photo" />
            {matchScore && (
              <span className="mls-splash__match-badge">{matchScore}% Match</span>
            )}
          </div>
        )}

        <div className="mls-splash__content">
          {address && (
            <h3 className="mls-splash__address">
              {address}
              {city && state ? `, ${city}, ${state}` : ""}
            </h3>
          )}

          <p className="mls-splash__message">
            {matchScore
              ? `This property matched at ${matchScore}% with your buyer's criteria.`
              : "This property matches your buyer's criteria."}
          </p>

          <div className="mls-splash__cta">
            <div className="mls-splash__cta-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 8.2c0 7.3-8 11.8-8 11.8z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <div>
              <h4>Full MLS Details Available</h4>
              <p>
                Photos, property history, tax records, and comparable sales are available
                with MLS integration. Contact your Cove MLS representative for full access.
              </p>
            </div>
          </div>

          <div className="mls-splash__actions">
            <button className="mls-splash__btn mls-splash__btn--primary" onClick={onClose}>
              Learn More About Cove MLS
            </button>
            <button className="mls-splash__btn mls-splash__btn--secondary" onClick={onClose}>
              Back to Matches
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MlsSplash;
